import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { TEST_LOCATORS } from '@src/constants/test-locators'

import StarYellow from '../productForm/icons/starYellow.svg'
import ReviewStars from '../reviews/reviewStars'

import styles from './productInfo.module.scss'
export interface ProductInfoReviewSummaryProps {
  avgRating?: number
  reviewCount?: number

  onReviewSummaryClick?: (e: React.MouseEvent<HTMLElement>) => void
  hideReviewCount?: boolean
  hideReviewLabel?: boolean
  productInfoReviewClassName?: string
  hideReviewSummary?: boolean
  showNewPdpDesignV2?: boolean
  updatedDesignForV2?: boolean
}

const ProductInfoReviewSummary = ({
  avgRating,
  reviewCount,
  onReviewSummaryClick,
  hideReviewCount,
  hideReviewLabel,
  productInfoReviewClassName,
  hideReviewSummary,
  showNewPdpDesignV2,
  updatedDesignForV2,
}: ProductInfoReviewSummaryProps) => {
  const { t } = useTranslation('common')
  if (hideReviewSummary || !avgRating || Number(reviewCount) <= 0) {
    return null
  }
  return (
    <div
      className={classnames(
        styles.container__ratingAndReviews,
        styles.container__ratingAndReviews_adjustedPadding,
        showNewPdpDesignV2 && styles.container__ratingAndReviews_newDesignV2,
        updatedDesignForV2 && styles.container__ratingAndReviews_updatedDesignV2,
      )}
      onClick={onReviewSummaryClick}
    >
      <ReviewStars
        totalStars={5}
        fillStars={avgRating}
        className={classnames(
          styles.container__ratingAndReviews__rating,
          styles.container__ratingAndReviews__rating_adjustedPadding,
          showNewPdpDesignV2 && styles.container__ratingAndReviews__rating_newDesignV2,
        )}
        classNameIcon={styles.reviewStarIcon}
        starSvg={showNewPdpDesignV2 ? (StarYellow as any) : undefined}
        showNewPdpDesignV2={showNewPdpDesignV2}
      />
      {reviewCount && !hideReviewCount && (
        <p
          data-testid={TEST_LOCATORS.FIRST_FOLD_REVIEW_COUNT}
          className={classnames(
            styles.container__ratingAndReviews__reviews,
            productInfoReviewClassName,
            styles.container__ratingAndReviews__reviews_adjustedPadding,
            showNewPdpDesignV2 && styles.container__ratingAndReviews__reviews_newDesignV2,
          )}
        >
          (
          <span>
            {reviewCount}
            {!hideReviewLabel && <>&nbsp;{reviewCount === 1 ? t('review') : t('reviews_v1')}</>}
          </span>
          )
        </p>
      )}
    </div>
  )
}

export default ProductInfoReviewSummary
